export enum Code {
  Enter = 'Enter',
  Escape = 'Escape',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Tab = 'Tab',
  Space = ' ',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Period = 'Period',
  Comma = 'Comma',
  Plus = 'Equal',
  Minus = 'Minus',
  Backslash = 'Backslash',
  ForwardSlash = 'Slash',
  Meta = 'Meta',
  Alt = 'Alt',
  Shift = 'Shift',
  Control = 'Control',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  Home = 'Home',
  End = 'End',
  T = 'KeyT',
  B = 'KeyB',
  I = 'KeyI',
  U = 'KeyU',
  A = 'KeyA',
  D = 'KeyD',
  Y = 'KeyY',
  L = 'KeyL',
  G = 'KeyG',
  C = 'KeyC',
  R = 'KeyR',
  Z = 'KeyZ',
}

export enum TagName {
  Button = 'BUTTON',
}

export enum Step {
  Small = 1,
  Medium = 10,
  Large = 15,
}
